export default "__VITE_ASSET__BM1w9PUY__"